var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AppConfig from '../../config/config';
import { mapProducts, mapSuggestedProducts, mapFilters, mapMeta, mapSorts } from './mapper';
import { fetchFredhopper, fetchFredhopperSuggestions } from './api';
export class FredhopperSearchProvider {
    constructor() {
        this.products = [];
        this.recs = [];
        this.filters = [];
        this.meta = null;
        this.sortOptions = [];
        this.suggestedTerms = [];
        this.suggestedExtras = [];
    }
    search(query_1) {
        return __awaiter(this, arguments, void 0, function* (query, options = {}) {
            var _a, _b, _c, _d, _e, _f, _g;
            const { page = 1, pageSize = AppConfig.page.defaultSize, sort = 'relevance', filters, merchandising, collectionId, matchesType } = options;
            try {
                // Format price filter if it exists
                const formattedFilters = filters ? Object.assign({}, filters) : undefined;
                if (formattedFilters === null || formattedFilters === void 0 ? void 0 : formattedFilters.price) {
                    // Ensure price filter is in the correct format (min,max)
                    formattedFilters.price = formattedFilters.price.map(value => {
                        // If value already contains ',', return as is
                        if (value.includes(','))
                            return value;
                        // Otherwise, ensure proper format
                        return value;
                    });
                }
                const data = yield fetchFredhopper({
                    q: query,
                    page,
                    pageSize,
                    sort,
                    filters: formattedFilters,
                    view: 'lister',
                    collection: collectionId,
                    matchesType,
                });
                // Extract items from the selected universe (matching Fredhopper Shopify app implementation)
                let selectedUniverse = null;
                if (((_a = data.universes) === null || _a === void 0 ? void 0 : _a.universe) && ((_b = data.info) === null || _b === void 0 ? void 0 : _b['current-universe'])) {
                    selectedUniverse = data.universes.universe.find(u => u.name === data.info['current-universe']);
                }
                if (!selectedUniverse && Array.isArray((_c = data.universes) === null || _c === void 0 ? void 0 : _c.universe)) {
                    selectedUniverse = data.universes.universe[0]; // fallback
                }
                const items = ((_e = (_d = selectedUniverse === null || selectedUniverse === void 0 ? void 0 : selectedUniverse['items-section']) === null || _d === void 0 ? void 0 : _d.items) === null || _e === void 0 ? void 0 : _e.item) || [];
                // Extract filters from facetmap (matching Fredhopper Shopify app implementation)
                const allFacetmaps = selectedUniverse === null || selectedUniverse === void 0 ? void 0 : selectedUniverse.facetmap;
                let facetmap = null;
                if (((_f = data.info) === null || _f === void 0 ? void 0 : _f.view) === 'search') {
                    const universeName = (_g = data.info) === null || _g === void 0 ? void 0 : _g['current-universe'];
                    if (universeName && allFacetmaps && Array.isArray(allFacetmaps)) {
                        facetmap = allFacetmaps.find(fm => { var _a; return ((_a = fm.universe) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === universeName.toLowerCase(); });
                        if (!facetmap) {
                            facetmap = allFacetmaps[0]; // fallback
                        }
                    }
                    else {
                        facetmap = allFacetmaps === null || allFacetmaps === void 0 ? void 0 : allFacetmaps[0];
                    }
                }
                else {
                    // For collections, use the first facetmap
                    facetmap = allFacetmaps === null || allFacetmaps === void 0 ? void 0 : allFacetmaps[0];
                }
                const allFilters = (facetmap === null || facetmap === void 0 ? void 0 : facetmap.filter) || [];
                // External attributes are custom attributes that are not part of Fredhopper API response.
                // They are added via our middleware API
                const externalAttributes = (data === null || data === void 0 ? void 0 : data['external_attributes']) || {};
                console.log('data', data);
                this.products = mapProducts(items, externalAttributes);
                this.filters = mapFilters(allFilters, formattedFilters);
                this.meta = mapMeta(data, page, pageSize);
                this.sortOptions = mapSorts();
            }
            catch (error) {
                console.error('[FredhopperSearchProvider] Search error:', error);
                throw new Error('Failed to load Fredhopper data');
            }
        });
    }
    fetchSuggestions(query, options) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e;
            try {
                const response = yield fetchFredhopperSuggestions(query);
                const suggestionGroups = (_a = response.suggestionGroups) !== null && _a !== void 0 ? _a : [];
                let productSuggestions = [];
                let keywordSuggestions = [];
                const extraSuggestions = [];
                for (const group of suggestionGroups) {
                    const name = (_c = (_b = group.indexName) === null || _b === void 0 ? void 0 : _b.toLowerCase()) !== null && _c !== void 0 ? _c : '';
                    if (name.includes('products')) {
                        productSuggestions = ((_d = group.suggestions) !== null && _d !== void 0 ? _d : []);
                        continue;
                    }
                    if (name.includes('keywords')) {
                        keywordSuggestions = ((_e = group.suggestions) !== null && _e !== void 0 ? _e : []);
                        continue;
                    }
                    extraSuggestions.push(group);
                }
                this.products = productSuggestions.length > 0 ? mapSuggestedProducts(productSuggestions) : [];
                this.suggestedTerms = keywordSuggestions.map((s) => ({ term: String(s.searchterm), score: s.nrResults }));
                this.suggestedExtras = extraSuggestions;
            }
            catch (error) {
                console.error('[FredhopperSearchProvider] fetchSuggestions error:', error);
                throw new Error('Failed to load Fredhopper suggestions');
            }
        });
    }
    fetchRecs(seedProductId_1, recsType_1) {
        return __awaiter(this, arguments, void 0, function* (seedProductId, recsType, forceRefetch = false) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            try {
                // Initialize window.mrRecommendations if not exists
                const mrRecommendations = window.mrRecommendations;
                if (!mrRecommendations) {
                    window.mrRecommendations = {};
                }
                if (!window.mrRecommendations.productDetails) {
                    window.mrRecommendations.productDetails = {};
                }
                let data;
                // Check if cached data exists and we're not forcing a refetch
                if (!forceRefetch && window.mrRecommendations.productDetails[seedProductId]) {
                    data = window.mrRecommendations.productDetails[seedProductId];
                }
                else {
                    data = yield fetchFredhopper({
                        view: 'detail',
                        secondid: seedProductId,
                    });
                    window.mrRecommendations.productDetails[seedProductId] = data;
                }
                // Extract items from the selected universe
                // For "detail view" object structure from Fredhopper response, refer to 'FredhopperProductDetailExampleResponses.md'
                let selectedUniverse = null;
                if (((_a = data.universes) === null || _a === void 0 ? void 0 : _a.universe) && ((_b = data.info) === null || _b === void 0 ? void 0 : _b['current-universe'])) {
                    selectedUniverse = data.universes.universe.find(u => u.name === data.info['current-universe']);
                }
                if (!selectedUniverse && Array.isArray((_c = data.universes) === null || _c === void 0 ? void 0 : _c.universe)) {
                    selectedUniverse = data.universes.universe[0]; // fallback
                }
                // Extract recommendation items from themes
                // Structure: themes[] -> theme[] -> theme object with custom-fields.campaign_slot and items
                const recommendationItems = [];
                if (selectedUniverse === null || selectedUniverse === void 0 ? void 0 : selectedUniverse.themes) {
                    for (const themeContainer of selectedUniverse.themes) {
                        if (!Array.isArray(themeContainer.theme))
                            continue;
                        for (const theme of themeContainer.theme) {
                            const campaignSlotField = (_e = (_d = theme['custom-fields']) === null || _d === void 0 ? void 0 : _d['custom-field']) === null || _e === void 0 ? void 0 : _e.find((field) => field.name === 'campaign_slot');
                            if (campaignSlotField && campaignSlotField.value === recsType) {
                                const items = (_f = theme.items) === null || _f === void 0 ? void 0 : _f.item;
                                if (items) {
                                    recommendationItems.push(...(Array.isArray(items) ? items : [items]));
                                }
                            }
                        }
                    }
                }
                // If no items found and we haven't forced a refetch, recursively call with fresh data
                if (recommendationItems.length === 0 && !forceRefetch) {
                    console.warn('[MR Fredhopper Recommendations] No recommendation items found in cached data, refetching...');
                    return this.fetchRecs(seedProductId, recsType, true);
                }
                this.recs = mapProducts(recommendationItems);
                this.meta = mapMeta(data, 1, AppConfig.page.defaultSize);
            }
            catch (error) {
                // If error occurred with cached data and we haven't tried refetching, try once more with fresh data
                if (!forceRefetch) {
                    console.warn('[MR Fredhopper Recommendations] Error processing cached data, refetching...', error);
                    if ((_h = (_g = window.mrRecommendations) === null || _g === void 0 ? void 0 : _g.productDetails) === null || _h === void 0 ? void 0 : _h[seedProductId]) {
                        delete window.mrRecommendations.productDetails[seedProductId];
                    }
                    return this.fetchRecs(seedProductId, recsType, true);
                }
                console.error('[MR Fredhopper Recommendations] Failed to fetch recommendations:', error);
                throw new Error('[MR Fredhopper Recommendations] Failed to load recommendations');
            }
        });
    }
    getProducts() {
        return this.products;
    }
    getSuggestedTerms() {
        return this.suggestedTerms;
    }
    getSuggestedExtras() {
        return this.suggestedExtras;
    }
    getRecs() {
        return this.recs;
    }
    getFilters() {
        return this.filters;
    }
    getMeta() {
        if (!this.meta) {
            throw new Error('No search has been performed yet');
        }
        return this.meta;
    }
    getSortOptions() {
        return this.sortOptions;
    }
}
